import React from 'react';
import { useIntl } from 'react-intl';
import {
  Alert,
  AlertBody,
  AlertIcon,
} from '@lifeomic/chroma-react/components/Alert';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { Button } from '@lifeomic/chroma-react/components/Button';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { AlertTriangle } from '@lifeomic/chromicons';
import { messages } from './messages';

export type OlderAnnualReportBannerProps = {
  newerActiveCarePlanId: string;
  onSwitchToLatest: (carePlanId: string) => void;
};

export const OlderAnnualReportBanner: React.FC<
  OlderAnnualReportBannerProps
> = ({ newerActiveCarePlanId, onSwitchToLatest }) => {
  const { formatMessage } = useIntl();

  return (
    <Alert statusType="warning" fullWidth>
      <AlertIcon icon={AlertTriangle} />
      <AlertBody>
        <Box direction="row" align="center" gap={1} flexWrap>
          <Text size="subbody">
            {formatMessage(messages.olderAnnualReportWarning)}
          </Text>
          <Button
            variant="text"
            onClick={() => onSwitchToLatest(newerActiveCarePlanId)}
          >
            {formatMessage(messages.switchToLatestAnnualReport)}
          </Button>
        </Box>
      </AlertBody>
    </Alert>
  );
};

OlderAnnualReportBanner.displayName = 'OlderAnnualReportBanner';
